import React, {useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import GraphIcon from "../../../../../../../assets/icons/GraphIcon";
import WebchatIcon from "../../../../../../../assets/icons/platforms/WebchatIcon";
import WebchatMobileIcon from "../../../../../../../assets/icons/platforms/WebchatMobileIcon";
import WebChatTest from "./components/WebChatTest";
import {
    getClientHardcodedMessages,
    getCompanyInfo,
    updateAiDescription,
    updateHardCodedMessage,
} from "../../../../../../../services/company/api";
import './Configurations.css';
import AIConfigs from "./AIConfigs";
import BotOverview from "../overview/BotOverview";
import HardcodedMessagesBottomTab from "./HardcodedMessagesBottomTab";
import Tooltip from "../../../../../../../components-new/general/Tooltip";
import config from "../../../../../../../config";
import Tabs from "../../../../../../../components-new/ui/Tabs";
import SilverButton from "../../../../../../../components-new/buttons/SilverButton";
import Colors from "../../../../../../../utils/Colors";

const TabIds = {
    en: 10,
    it: 20,
    es: 30
};

const Configurations = ({tariff, client, user, addNotification, handleImageChange, fetchCompany}) => {
    const {features} = tariff;
    const [showChat, setShowChat] = useState({});
    const [hardCodedMessages, setHardCodedMessages] = useState();
    const [activeTabId, setActiveTabId] = useState(TabIds.en);
    const [localeOption, setLocaleOption] = useState(config.localesOptions[0]);
    const [companyInfo, setCompanyInfo] = useState()

    const [aiType, setAiType] = useState();
    const [aiContentLoadingHours, setAiContentLoadingHours] = useState();
    const [aiHumanOnlyHours, setAiHumanOnlyHours] = useState();
    const [aiDescription, setAiDescription] = useState();
    const [aiSupportedLanguages, setAiSupportedLanguages] = useState();

    const [activeTab, setActiveTab] = useState('treeAndTest');

    useEffect(() => {
        // Failing this quietly was leaving the AI tab half-built: aiType stayed
        // undefined, and every block keyed on it - api key, style, behaviour,
        // knowledge - decided it was not applicable and rendered nothing, while the
        // blocks fed from props still drew themselves. The panel looked complete and
        // was missing half its settings.
        getCompanyInfo(client.id).then((data) => {
            setCompanyInfo(data);
            setAiType(data.aiType);
            setAiDescription(data.companyDescriptionForAI);
            setAiContentLoadingHours(data.aiContentLoadingHours);
            setAiHumanOnlyHours(data.aiHumanOnlyHours);
            setAiSupportedLanguages(data.aiSupportedLanguages ? data.aiSupportedLanguages : 'all');
        }).catch(() => {
            addNotification('somethingWentWrong', config.notificationLevels.error, {});
        })
        getClientHardcodedMessages(client.id).then((data) => {
            setHardCodedMessages(data);
        });
    }, [client.id]);

    useEffect(() => {
        setActiveTab('treeAndTest')
    }, [client])

    const updateHardCodedMessages = (type, locale) => {
        return text => updateHardCodedMessage(client.id, type, locale, text)
            .then(() => {
                setHardCodedMessages(prevMessages => ({
                    ...prevMessages,
                    [type]: {
                        ...prevMessages[type],
                        [locale]: text
                    }
                }));
            });
    };

    const toggleChat = (clientId) => {
        setShowChat(prevShowChat => ({
            ...prevShowChat,
            [clientId]: !prevShowChat[clientId]
        }));
    };

    const handleToggleChat = (clientId) => {
        toggleChat(clientId);
    };

    function handleToggleMobileChat(companyId) {
        const version = "1.7.4";
        const url = `${config.WEBCHAT_HOST}/?version=${version}&companyId=${companyId}&mobile=true`;

        const width = 430;
        const height = 630;

        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popup = window.open(
            url,
            "mobileChatPreview",
            `width=${width},height=${height},left=${left},top=${top},` +
            `resizable=yes,scrollbars=yes,status=no,menubar=no,toolbar=no,location=no`
        );

        if (popup) {
            popup.focus();
        }
    }

    const handleAiDescriptionChange = (event) => {
        setAiDescription(event.target.value);
    };

    const handleSaveAiDescription = () => {
        updateAiDescription(client.id, aiDescription)
            .then(() => {
                setAiDescription(aiDescription);
            });
    };

    const tabs = [

        /*
         * One label for both kinds of bot. It used to read "Tree and testing"
         * for a scenario bot and "Web chat testing" for a smart one - two names
         * for the same tab, neither of which covered what is on it now.
         */
        ...(companyInfo ? [{label: "botOverview", value: "treeAndTest"}] : []),
        ...(features.includes(config.features.HARDCODED_MESSAGES)
            ? [{label: "hardcodedMessages", value: "hardcodedMessages"}]
            : []),

        ...(companyInfo && companyInfo.companyType === config.companyTypeMap.smart && features.includes(config.features.AI)
            ? [{label: "configsAI", value: "configsAI"}]
            : []),

    ];
    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>

            <div style={{marginBottom: '20px'}}>
                <Tabs
                    selectedTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={tabs}
                />
            </div>

            {activeTab === 'treeAndTest' && companyInfo && (
                <BotOverview
                    client={client}
                    isScenario={client.type === config.companyTypeMap.scenario}
                    onOpenChat={() => handleToggleChat(client.id)}
                    onOpenMobileChat={() => handleToggleMobileChat(client.id)}
                    onImageChange={handleImageChange}
                    refreshCompany={fetchCompany}
                    addNotification={addNotification}
                />
            )}

            <div style={{minHeight: 0}}>
                {features.includes(config.features.HARDCODED_MESSAGES) && activeTab === 'hardcodedMessages' &&
                    <div className="bg-white" style={{height: '100%'}}>
                        <div className="configurations-forbidden-words-container">
                            {hardCodedMessages && (
                                <HardcodedMessagesBottomTab
                                    features={features}
                                    client={client}
                                    hardCodedMessages={hardCodedMessages}
                                    activeTabId={activeTabId}
                                    config={config}
                                    localeOption={localeOption}
                                    updateHardCodedMessages={updateHardCodedMessages}
                                    user={user}
                                />
                            )}
                        </div>
                    </div>
                }

                {features.includes(config.features.AI)
                    && activeTab === 'configsAI' &&
                    <div className="ai-tab">
                        <div className="configurations-forbidden-words-container">
                            {/* the shared .configurations-header is a fixed-height
                                block, and this tab already names itself through the
                                active tab above; hidden for now, kept because the
                                other tabs all carry one */}
                            {/*
                            <h2 className="configurations-header ai-tab-header">
                                <Translate text="configsAI"/>
                                <Tooltip text="aiTabExplanation" inRightSide style={{display: 'flex'}}>
                                    <span className="ai-tab-header__hint">
                                        <InfoIcon width={16} height={16} style={{color: Colors.silverBlueLite}} stroke="currentColor"/>
                                    </span>
                                </Tooltip>
                            </h2>
                            */}
                            <AIConfigs
                                addNotification={addNotification}
                                setAiType={setAiType}
                                aiSupportedLanguages={aiSupportedLanguages}
                                setAiSupportedLanguages={setAiSupportedLanguages}
                                aiType={aiType}
                                features={features}
                                user={user}
                                aiDescription={aiDescription}
                                handleAiDescriptionChange={handleAiDescriptionChange}
                                handleSaveAiDescription={handleSaveAiDescription}
                                client={client}
                                aiContentLoadingHours={aiContentLoadingHours}
                                setAiContentLoadingHours={setAiContentLoadingHours}
                                aiHumanOnlyHours={aiHumanOnlyHours}
                                setAiHumanOnlyHours={setAiHumanOnlyHours}
                            />
                        </div>
                    </div>
                }

            </div>

            {showChat[client.id] && <WebChatTest key={client.id} companyId={client.id}/>}
        </div>
    );
};

export default Configurations;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/Configurations.jsx